class BhHeader extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('[data-drawer]');
    this.overlay = this.querySelector('[data-drawer-overlay]');
    this.openButton = this.querySelector('[data-drawer-open]');

    this.openButton?.addEventListener('click', () => this.toggleDrawer(true));
    this.querySelector('[data-drawer-close]')?.addEventListener('click', () => this.toggleDrawer(false));
    this.overlay?.addEventListener('click', () => this.toggleDrawer(false));

    this.onKeydown = (event) => {
      if (event.key === 'Escape') this.toggleDrawer(false);
    };
    document.addEventListener('keydown', this.onKeydown);

    // Dropdown toggles: open on click/tap (hover handled by CSS on desktop).
    for (const trigger of this.querySelectorAll('.dropdown-trigger')) {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const item = trigger.closest('.has-dropdown');
        const isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    // Announcement bar: explicit click always opens the signup popup, even
    // if the visitor already dismissed it (intent here overrides suppression).
    this.querySelector('[data-open-signup-popup]')?.addEventListener('click', (event) => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('bh:open-signup-popup'));
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  toggleDrawer(open) {
    if (!this.drawer) return;
    this.drawer.classList.toggle('is-open', open);
    this.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (this.overlay) this.overlay.hidden = !open;
    this.openButton?.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('drawer-open', open);
  }
}

customElements.define('bh-header', BhHeader);
